export default __webpack_public_path__ + "fd23712051bbe2993bacb1adb458b764.svg";